import { render, staticRenderFns } from "./listChatBotMobile.vue?vue&type=template&id=368503b6&scoped=true"
import script from "./listChatBotMobile.vue?vue&type=script&lang=js"
export * from "./listChatBotMobile.vue?vue&type=script&lang=js"
import style0 from "./listChatBotMobile.vue?vue&type=style&index=0&id=368503b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368503b6",
  null
  
)

export default component.exports